export function formatNumberWithLeadingZeros(num: number): string {
  const str = num.toString();
  const leadingZeros = '0'.repeat(5 - str.length);
  return leadingZeros + str;
}
